import { SCHEME_IMAGES } from "../../config/config";

export const getSchemeImage = (schemeTableId) => {
  const schemeImageUrl = SCHEME_IMAGES[schemeTableId];

    if (schemeImageUrl) {
      return (
        <img
          src={schemeImageUrl}
          alt={`Logo for scheme ${schemeTableId}`}
          className="company-logo"
        />
      );
    } else {
      return <span>No image for {schemeTableId}</span>;
    }
  };